import { getPaymentCards } from "../../../../app/api/getPaymentCards";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse, IPaymentCard, IPaymentCards } from "../../../../Orchestrator/Types/Index";
import { IGetPaymentCardActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/PaymentCardsActionParams";


class GetPaymentCardsAction extends BaseAction<IPaymentCards, IGetPaymentCardActionParams> {
    override async run(): Promise<IPaymentCards | null> {
        let paymentCardsResponses: IPaymentCards | null = null;
        try {
            const { userId } = this.params!;
            if (userId) {
                const response: IApiResponse<IPaymentCard[]> = await getPaymentCards(userId);

                if (response.status === "ok" && response.answer) {
                    const paymentCardsArray = response.answer;
                    if (paymentCardsArray && Array.isArray(paymentCardsArray)) {
                        paymentCardsResponses = { paymentCards: paymentCardsArray };
                        updateRecoilState("paymentCardsAtom", paymentCardsArray);
                    } else {
                        console.warn("No Card List available.");
                    }
                } else {
                    console.warn("Failed to fetch Card List.");
                }
            }
        } catch (error: any) { }
        finally {
            return paymentCardsResponses;
        }
    }
}

export const getPaymentCardsAction = new GetPaymentCardsAction()


